import './App.css';
import EnquiryForm from './components/EnquiryForm';
import Cookies from 'js-cookie';
import Thankyou from './components/Thankyou';
import { COOKIE_NAME } from './constants/Constants';

function App() {
  let userExists = Cookies.get(COOKIE_NAME);
  let enquirySubmitted = userExists !== undefined;
  return (
    <div className="App" style={{fontFamily:'proxima-nova'}}>
      <header className="App-header">
      </header>
      <div hidden={enquirySubmitted}>
        <EnquiryForm />
      </div>
      <div hidden={!enquirySubmitted}>
        <Thankyou/>
      </div>
    </div>
  );
}

export default App;
